import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import LoadingScreen from '../../components/LoadingScreen';
import ErrorContent from '../../components/ErrorContent.js';
import NoContent from '../../components/NoContent';
import Breadcrumbs from '../../components/Breadcrumbs';
import { areaServiceListAreas } from '../../api/area';
import { pastExamBookletServiceListPastExamBooklets } from '../../api/past_exam_booklet';
import { examGroupServiceListExamGroups } from '../../api/exam_group';
import { examTypeServiceListExamTypes } from '../../api/exam_type';
import { lessonServiceListLessons } from '../../api/lesson';
import { pastExamServiceListPastExams } from '../../api/past_exam';
import { academicYear, examStatus } from '../../api/types';

function Exams() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const [breadcrumbData, setBreadcrumbData] = useState(null);

    const [areas, setAreas] = useState([]);
    const [booklets, setBooklets] = useState([]);
    const [examGroups, setExamGroups] = useState([]);
    const [examTypes, setExamTypes] = useState([]);
    const [lessons, setLessons] = useState([]);
    const [formAreaId, setFormAreaId] = useState(searchParams.get('areaId') || "")
    const [formExamGroupId, setFormExamGroupId] = useState(parseInt(searchParams.get('examGroupId')) || "")
    const [formExamTypeId, setFormExamTypeId] = useState(parseInt(searchParams.get('examTypeId')) || "")
    const [formLessonId, setFormLessonId] = useState(parseInt(searchParams.get('lessonId')) || "")
    const [formAcademicYear, setFormAcademicYear] = useState(parseInt(searchParams.get('academicYear')) || academicYear().ACADEMIC_YEAR_UNSPECIFIED)
    const [formStatus, setFormStatus] = useState(parseInt(searchParams.get('status')) || examStatus().EXAM_STATUS_UNSPECIFIED)

    const loadScreen = async () => {
        try {
            await loadAreas();
            await loadBooklets();
            await loadExamGroups();
            await loadExamTypes();
            await loadLessons();
            await loadExams();
            setLoading(false);
        } catch (err) {
            console.log(err);
            setError(err);
            setLoading(false);
        }
    };

    const loadAreas = async () => {
        const response = await areaServiceListAreas();
        setAreas(response.toObject().areasList);
    }

    const loadBooklets = async () => {
        const response = await pastExamBookletServiceListPastExamBooklets({});
        setBooklets(response.toObject().pastExamBookletsList);
    }

    const loadExams = async () => {
        const response = await pastExamServiceListPastExams({
            areaId: formAreaId,
            examGroupId: formExamGroupId,
            examTypeId: formExamTypeId,
            academicYear: formAcademicYear,
            lessonId: formLessonId,
            status: formStatus
        });
        setData(response.toObject().pastExamsList);
    }

    const loadExamGroups = async () => {
        const response = await examGroupServiceListExamGroups({});
        setExamGroups(response.toObject().examGroupsList);
    }

    const loadLessons = async () => {
        const response = await lessonServiceListLessons({});
        setLessons(response.toObject().lessonsList);
    }

    const loadExamTypes = async () => {
        const response = await examTypeServiceListExamTypes({});
        setExamTypes(response.toObject().examTypesList);
    }

    useEffect(() => {
        setSearchParams({
            areaId: formAreaId,
        });

        console.log("reload data");
        const fetchData = async () => {

            await loadExams();
        }
        fetchData();
    }, [formAreaId, formExamGroupId, formExamTypeId, formLessonId, formAcademicYear, formStatus]);

    useEffect(() => {
        document.title = "SINAVLAR"

        setBreadcrumbData([
            { name: 'Dash', url: '/' },
            { name: 'Sınavlar', url: '' },
        ]);
        loadScreen();
    }, []);

    const RenderContent = () => {
        if (loading) {
            return (
                <LoadingScreen />
            );
        }
        else if (error !== null) {
            return (
                <ErrorContent error={error} clickFunction={() => console.log("Tekrar Yükle")} />
            );
        }
        else {
            return (
                <table className="card-body table">
                    <thead>
                        <tr>
                            <th scope="col">Alan</th>
                            <th scope="col">Grup</th>
                            <th scope="col">Tip</th>
                            <th scope="col">Ders</th>
                            <th scope="col">Kod</th>
                            <th scope="col">Akademik Yıl</th>
                            <th scope="col">Tarih</th>
                            <th scope="col">Durum</th>
                            <th scope="col">İşlemler</th>
                        </tr>
                        <tr>
                            <th scope="col">
                                <select id="form-area" className="form-select form-select-sm" select={formAreaId} value={formAreaId} onChange={e => {
                                    setFormAreaId(e.target.value);
                                    setFormExamGroupId("");
                                    setFormExamTypeId("");
                                    setFormLessonId("");
                                }}>
                                    <option key={`area-0`} value={""}>Belirtilmemiş</option>
                                    {
                                        areas.map((item, index) => (
                                            <option key={`area-${index}`} value={item.id}>{item.title}</option>
                                        ))
                                    }
                                </select>
                            </th>
                            <th scope="col">
                                <select disabled={formAreaId == ""} id="form-exam-group" className="form-select form-select-sm" select={formExamGroupId} value={formExamGroupId} onChange={e => setFormExamGroupId(e.target.value)}>
                                    <option key={`exam-group-0`} value={""}>Belirtilmemiş</option>
                                    {
                                        examGroups.filter(s => s.areaId == formAreaId).map((item, index) => (
                                            <option key={`exam-group-${index}`} value={item.id}>{item.title}</option>
                                        ))
                                    }
                                </select>
                            </th>
                            <th scope="col">
                                <select disabled={formAreaId == ""} id="form-exam-type" className="form-select form-select-sm" select={formExamTypeId} value={formExamTypeId} onChange={e => setFormExamTypeId(e.target.value)}>
                                    <option key={`exam-type-0`} value={""}>Belirtilmemiş</option>
                                    {
                                        examTypes.filter(s => s.areaId == formAreaId).map((item, index) => (
                                            <option key={`exam-type-${index}`} value={item.id}>{item.title}</option>
                                        ))
                                    }
                                </select>
                            </th>
                            <th scope="col" colSpan={2}>
                                <select disabled={formAreaId == ""} id="form-lesson" className="form-select form-select-sm" select={formLessonId} value={formLessonId} onChange={e => setFormLessonId(e.target.value)}>
                                    <option key={`lesson-0`} value={""}>Belirtilmemiş</option>
                                    {
                                        lessons.filter(s => s.area.id == formAreaId).map((item, index) => (
                                            <option key={`lesson-${index}`} value={item.id}>{item.title} ({item.code})</option>
                                        ))
                                    }
                                </select>
                            </th>
                            <th>
                                <select id="form-academic-year" className="form-select form-select-sm" select={formAcademicYear} value={formAcademicYear} onChange={e => setFormAcademicYear(e.target.value)}>
                                    {
                                        Object.values(academicYear()).map((value, index) => (
                                            <option key={"academic-year" + index} value={value}>{academicYear(value)}</option>
                                        ))
                                    }
                                </select>

                            </th>
                            <th></th>
                            <th>
                                <select id="form-status" className="form-select form-select-sm" select={formStatus} value={formStatus} onChange={e => setFormStatus(e.target.value)}>
                                    {
                                        Object.values(examStatus()).map((value, index) => (
                                            <option key={"status" + index} value={value}>{examStatus(value)}</option>
                                        ))
                                    }
                                </select>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data === null || data.length === 0 ? <tr><td colSpan={7} className='text-center'>Sınav bulunamadı.</td></tr> : data.map((item, Index) => {
                                return (
                                    <tr key={"area_" + Index}>
                                        <td >{areas.find(s => s.id == item.area.id)?.title ?? "-"} </td>
                                        <td >{examGroups.find(s => s.id == item.examGroup.id)?.title ?? "-"} </td>
                                        <td >{examTypes.find(s => s.id == item.examType.id)?.title ?? "-"} </td>
                                        <td >{lessons.find(s => s.id == item.lesson.id)?.title ?? "-"} </td>
                                        <td >{lessons.find(s => s.id == item.lesson.id)?.code ?? "-"} </td>
                                        <td>{academicYear(item.academicYear)}</td>
                                        <td>{item.date ? new Date(item.date.seconds * 1000).toISOString().slice(0, -5).replace("T", " ") : "-"}</td>
                                        <td>{examStatus(item.status)}</td>
                                        <td>
                                            <div className="btn-group" role="group">

                                                <Link to={`${item.id.toString()}/trim`} className="btn btn-sm btn-outline-secondary" role="button">KIRP</Link>
                                                <Link to={`${item.id.toString()}/preview`} className="btn btn-sm btn-outline-primary" role="button">ÖNİZLE</Link>
                                                {/* <Link to={item.id.toString()} className="btn btn-sm btn-outline-primary" role="button">ÖNİZLE</Link>
                                                <Link to={item.id.toString()} className="btn btn-sm btn-outline-secondary" role="button">DÜZENLE</Link> */}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            );
        }
    };

    return (
        <>
            <div className="container-fluid">

                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <Breadcrumbs data={breadcrumbData} />
                        <div className="btn-group">
                            <Link to="create" className="btn btn-sm btn-primary">+</Link>
                        </div>
                    </div>
                    {RenderContent()}

                </div>
            </div>

        </>
    );
}

export default Exams;